import React from "react";

import { StandardBetSB } from "@/modules/commonMobile";
import { IGameType } from "@/types/GlobalTypes";

interface IProps {
	game: IGameType;
	isBetClosed: boolean;
	activateBetGroup: (e: React.MouseEvent) => void;
}

//COPIED FROM ShioBallsTabs
export default class LottoTabs extends React.Component<IProps> {
	render() {
		const game = this.props.game;
		const activeBetGroup = game.activeBetGroup || "";

		return (
			<div className={"tabs" + (this.props.isBetClosed ? " bet-closed" : "")}>
				{
					StandardBetSB({
						classes: "sl-machine-tab" + (activeBetGroup === "random" ? " active" : ""),

						betLabel: "Random",
						betNum: "",
						betGroup: `random`,

						commonProps: game,
						onClick: this.props.activateBetGroup,

						isTopRow: true,
					})
				}

				{
					StandardBetSB({
						classes: "sl-machine-tab" + (activeBetGroup === "order" ? " active" : ""),

						betLabel: "Order",
						betNum: "",
						betGroup: `order`,

						commonProps: game,
						onClick: this.props.activateBetGroup,

						isTopRow: true,
					})
				}
			</div>
		);
	}
}
